import { render, staticRenderFns } from "./ListFailedDemos.vue?vue&type=template&id=529d8a09&"
import script from "./ListFailedDemos.vue?vue&type=script&lang=ts&"
export * from "./ListFailedDemos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports